import React, { useContext, useEffect, useRef, useState } from 'react';
import t from 'react-translate';
import { AngularContext } from 'react-app';
import TopPanelActionButton from 'lecture_pages/components/edit-menu/actions/top-panel-action-button';
import { config } from '@config/config.json';

const CardViewButton = () => {
  const { $scope, injectServices } = useContext(AngularContext);
  const [$stateParams, ConfirmationOverlays, TimelinesManager, CurrentCourseManager] = injectServices([
    '$stateParams',
    'ConfirmationOverlays',
    'TimelinesManager',
    'CurrentCourseManager',
  ]);
  const [isCardView, setIsCardView] = useState<boolean>(!!CurrentCourseManager.course.cardView);
  const [lecturePagesLength, setLecturePagesLength] = useState(
    TimelinesManager.currentTimeline?.lecturePages?.length || 0,
  );
  const isDisabled = !lecturePagesLength;
  const blurActiveElement = () => {
    const activeElement = document.activeElement as HTMLElement;
    activeElement?.blur();
  };

  useEffect(() => {
    const unwatchLecturePages = $scope?.$watch(
      () => TimelinesManager.currentTimeline?.lecturePages?.length,
      (newValue) => {
        setLecturePagesLength(newValue || 0);
      },
    );

    const unwatchCardView = $scope?.$watch(
      () => CurrentCourseManager.course.cardView,
      (newValue) => {
        setIsCardView(!!newValue);
      },
    );

    return () => {
      unwatchLecturePages?.();
      unwatchCardView?.();
    };
  }, [$scope, TimelinesManager, CurrentCourseManager]);

  const handleToggleCardView = () => {
    if (!isCardView) {
      ConfirmationOverlays.openConfirmationModal(
        'timelines/templates/card-view-confirmation-overlay.html',
        'AttachModalResolvesToVmCtrl',
        {
          vmResolves() {
            return {
              CurrentCourseManager,
              TimelinesManager,
            };
          },
        },
      ).result.then(() => {
        TimelinesManager.toggleCardView($stateParams.catalogId);
        $scope?.$applyAsync?.();
        blurActiveElement();
      });
    } else {
      TimelinesManager.toggleCardView($stateParams.catalogId);
      $scope?.$applyAsync?.();
      blurActiveElement();
    }
  };

  return (
    <TopPanelActionButton
      icon='card-view'
      iconClassName={isCardView ? 'text-warning' : 'text-white'}
      tooltipText={isCardView
        ? t.TIMELINE.DISABLE_CARD_VIEW()
        : t.TIMELINE.ENABLE_CARD_VIEW.TITLE()
      }
      onClick={handleToggleCardView}
      disabled={isDisabled}
      ariaLabel={isCardView
        ? t.TIMELINE.DISABLE_CARD_VIEW()
        : t.TIMELINE.ENABLE_CARD_VIEW.TITLE()
      }
      dataQa={config.pendo.outline.admin.cardViewButton}
    />
  );
};

export default CardViewButton;
